import React, { useEffect, useState } from 'react'
import TinderCard from 'react-tinder-card'
import './TinderCards.css'
import database from './firebase'

function TinderCards() {
    const [people,setPeople] = useState([
        {
            name:'Alex',
            url:'https://image.shutterstock.com/image-photo/close-portrait-smiling-handsome-man-600w-1011569245.jpg'
        },
        {
            name:'Betty',
            url:'https://image.shutterstock.com/image-photo/closeup-portrait-young-attractive-stylish-600w-1753317011.jpg'
        }
    ]);
    useEffect(()=>{
        // fill people state with data from firestore db
        const unsubscribe = database.collection("people").onSnapshot(snapshot=>(setPeople(snapshot.docs.map((doc)=>doc.data()))))

        return () => {
            // this is cleanup
            unsubscribe();
        }
    },[])

    return (
        <div className="tinderCard">
            <div className="tinderCard__cardContainer">
                {people.map(person=>(
                    <TinderCard className="swipe" key={person.name} preventSwipe={["up","down"]}>
                        <div className="card" style={{backgroundImage:`url(${person.url})`}} >
                            <h3>{person.name}</h3>
                        </div>
                    </TinderCard>
                ))}
            </div>
        </div>
    )
}

export default TinderCards
